import { useMsal } from "@azure/msal-react";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { USER_AUTH_TYPE } from "../../enums/user-auth-type.enum";
import { ProgramType } from "../../models/program-type.model";

type SuccessInvitationModalProps = {
  show: boolean;
  handleClose: () => void;
  inviteLink: string;
  isUpdateInvitation: boolean;
  program: string;
};
export default function SuccessInvitationModal({
  show,
  handleClose,
  inviteLink,
  isUpdateInvitation,
  program,
}: SuccessInvitationModalProps) {
  const { instance } = useMsal();
  const copyInviteLink = async () => {
    try {
      await navigator.clipboard.writeText(inviteLink);
      alert("Invite link has been copied to clipboard");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const acknowledge = () => {
    instance.logoutRedirect({
      authority: `${process.env.REACT_APP_MSAL_AUTHORITY}/${USER_AUTH_TYPE.COMARCH_EMPLOYEE}`,
      postLogoutRedirectUri: `${process.env.REACT_APP_BASE_URL}/success-invitation`,
    });
  };

  return (
    <Modal show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Success!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You can copy the below invitation link to send to the owner through a
          personalized email.
        </p>
        <h3 className="mt-4 font-medium">Invitation Link</h3>
        <div className="mt-2">
          <span>
            <code>{inviteLink}</code>
          </span>
          <span
            onClick={copyInviteLink}
            className="cursor-pointer position-relative top-1 inline-block left-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
              />
            </svg>
          </span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-between w-full">
          <Button variant="primary" className="flex-1" onClick={acknowledge}>
            Acknowledge
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
